const toList = (v) => (Array.isArray(v) ? v : (v ? [v] : []));

const itemCategories = (item, skills) => {
    const categories = toList(item?.Categories);
    const skillName = item?.SkillKey && skills?.find((s) => s.Key === item.SkillKey)?.skill;
    return skillName && !categories.includes(skillName) ? [...categories, skillName] : categories;
};

export const matchesCategoryLimit = (attachment, item, skills) => {
    if (!attachment.CategoryLimit) { return true; }
    const limits = toList(attachment.CategoryLimit);
    return itemCategories(item, skills).some((c) => limits.includes(c)) || limits.includes(item?.Type);
};

export default itemCategories;
